var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar-image"},[_c('div',{staticClass:"avatar-parent-child",staticStyle:{"width":"max-content"}},[_c('img',{staticClass:"avatar rounded-circle",attrs:{"src":_vm.photo,"alt":"Image placeholder"}}),_c('span',{staticClass:"avatar-child avatar-badge bg-success"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }